export default {
  FETCH_TAGS_PAGE: 'FETCH_TAGS_PAGE',
  FETCH_TAGS_PAGE_SUCCESS: 'FETCH_TAGS_PAGE_SUCCESS',
  FETCH_TAGS_PAGE_ERROR: 'FETCH_TAGS_PAGE_ERROR',

  FETCH_RELATED_COMMUNITIES: 'FETCH_RELATED_COMMUNITIES',
  FETCH_RELATED_COMMUNITIES_SUCCESS: 'FETCH_RELATED_COMMUNITIES_SUCCESS',
  FETCH_RELATED_COMMUNITIES_ERROR: 'FETCH_RELATED_COMMUNITIES_ERROR',
}
